import { AuthProvider, useAuth } from "./providers/authProvider";
import { DataProvider } from "./providers/dataProvider";
import { LoginScreen } from "./components/LoginScreen";
import { Dashboard } from "./components/Dashboard";
import { InviteGate, captureInviteHash } from "./components/InviteGate";
import { ErrorBoundary } from "./components/ErrorBoundary";

// Stash an invite token before anything renders, so it survives the login screen.
captureInviteHash();

const Router = () => {
  const { auth } = useAuth();
  if (auth.status === "loading") {
    return <div className="min-h-screen" />;
  }
  if (auth.status === "loggedOut") {
    return <LoginScreen />;
  }
  return (
    <ErrorBoundary>
      <DataProvider>
        <InviteGate />
        <Dashboard />
      </DataProvider>
    </ErrorBoundary>
  );
};

export const App = () => (
  <AuthProvider>
    <Router />
  </AuthProvider>
);
